/**
 * Tiempo relativo en palabras para las listas («hace 3 d»).
 *
 * Vive aquí y no en cada componente porque el agente lo usa en tres pantallas
 * (credenciales, comandos y operación) y antes cada una lo escribía a su
 * manera: unas en segundos, otras en días.
 *
 * El texto es corto a propósito: cabe en una celda de tabla bajo la fecha.
 */
export function hace(fecha) {
  if (!fecha) return null;
  const ms = Date.now() - new Date(fecha).getTime();
  if (Number.isNaN(ms)) return null;
  if (ms < 0) return 'en el futuro';
  const seg = Math.floor(ms / 1000);
  if (seg < 60) return `hace ${seg} s`;
  const min = Math.floor(seg / 60);
  if (min < 60) return `hace ${min} min`;
  const horas = Math.floor(min / 60);
  if (horas < 24) return `hace ${horas} h`;
  const dias = Math.floor(horas / 24);
  if (dias < 30) return `hace ${dias} d`;
  const meses = Math.floor(dias / 30);
  if (meses < 12) return `hace ${meses} meses`;
  return `hace ${Math.floor(meses / 12)} años`;
}

export default hace;
